import React, { useRef } from 'react';
import ProcedureActionOverlay from './ProcedureActionOverlay';
import IProcedureActionOverlayDetail from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureActionOverlayDetail';
import { Guid } from '@Shared.Angular/@types/guid';

interface ProcedureActionOverlayEditorProps {
  imageDataUrl: string;
  containerClassName?: string;
  overlays: IProcedureActionOverlayDetail[];
  onOverlayUpdated: (
    id: Guid,
    x: number,
    y: number,
    width: number,
    height: number
  ) => void;
  onOverlayDeleted?: (id: Guid) => void;
}

const ProcedureActionOverlayEditor: React.FC<
  ProcedureActionOverlayEditorProps
> = ({
  imageDataUrl,
  containerClassName = '',
  overlays,
  onOverlayUpdated,
  onOverlayDeleted
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [imageDimensions, setImageDimensions] = React.useState<{
    width: number;
    height: number;
  }>({ width: 0, height: 0 });

  const containerWidth = containerRef.current?.offsetWidth || 0;
  const scale =
    imageDimensions.width === 0
      ? 0
      : imageDimensions.width > containerWidth
      ? containerWidth / imageDimensions.width
      : 1;

  return (
    <div ref={containerRef} className={`overlay-editor ${containerClassName}`}>
      <img
        src={imageDataUrl}
        alt="Procedure Action"
        onLoad={(e) => {
          const img = e.target as HTMLImageElement;
          setImageDimensions({
            width: img.naturalWidth,
            height: img.naturalHeight
          });
        }}
      />
      {overlays.map((overlay) => (
        <ProcedureActionOverlay
          key={overlay.id}
          scale={scale}
          containerRef={containerRef}
          overlay={overlay}
          onOverlayUpdated={onOverlayUpdated}
          onOverlayDeleted={onOverlayDeleted}
        />
      ))}
    </div>
  );
};

export default ProcedureActionOverlayEditor;
